module.exports = __webpack_public_path__ + "static/projekty-opakowan-letopic-7356286a2794c621a137e39b1c574d00.jpg";